import { openDB } from 'idb';
import { Batch } from '../_models';

const ITEACH_DB_NAME = 'iteachDB';
export const STUDENT_STORE_NAME = 'Student';
export const STUDENT_STORE_INDEX_BATCH = 'student_batchId_unique';
export const BATCH_STORE_NAME = 'batch_master';
//export const BATCH_STORE_INDEX_INSTRUCTOR = 'batch_instructorId_unique'
export const TIMETABLE_STORE_NAME = 'timetable_template';
export const TIMETABLE_STORE_INDEX_BATCH = 'timetable_batchId_unique';
export const SCHEDULE_ACTIVITY_SLOT_STORE_NAME = 'schedule_activity_slot';
export const SCHEDULE_ACTIVITY_SLOT_STORE_DATE_INDEX = 'schedule_activity_date_unique';
export const SCHEDULE_ACTIVITY_SLOT_STORE_SYNC_STATUS_INDEX = 'schedule_activity_sync_status_unique';
export const LESSON_PLAN_STORE_NAME = 'lesson_plan_master';
export const LESSON_PLAN_STORE_BATCHID_INDEX = 'lesson_plan_batchId_unique';
export const LESSON_PLAN_STORE_TOPICID_INDEX = 'lesson_plan_topicId_unique';
export const LESSON_PLAN_STEP_STATUS_STORE_NAME = 'lesson_plan_step_status';
export const LESSON_PLAN_STEP_STATUS_LESSONPLANID_INDEX = 'lesson_plan_step_status_lessonplanId_unique';
export const LESSON_PLAN_STEP_STATUS_SYNC_STATUS_INDEX = 'lesson_plan_step_status_sync_status_unique';
 
export class DbService {
    public iteachDB;
    constructor(){
    }

  async connect(): Promise<void> {
    this.iteachDB = await openDB(ITEACH_DB_NAME, 1,
        {
          upgrade(db) {
            let store = db.createObjectStore(STUDENT_STORE_NAME, { keyPath: 'id', autoIncrement: true });
            store.createIndex(STUDENT_STORE_INDEX_BATCH, 'batchId', {unique: false});
            //'CREATE TABLE IF NOT EXISTS student (Id INTEGER, Name VARCHAR, StudentCode Text, BatchId INTEGER);' +
            let batchStore = db.createObjectStore(BATCH_STORE_NAME, { keyPath: 'id', autoIncrement: true });
            //batchStore.createIndex(BATCH_STORE_INDEX_INSTRUCTOR, 'instructorId', {unique: false});
            let timetableStore = db.createObjectStore(TIMETABLE_STORE_NAME, { keyPath: 'id', autoIncrement: true });
            timetableStore.createIndex(TIMETABLE_STORE_INDEX_BATCH, 'batchId', {unique: false});
            let scheduleActivitySlotStore = db.createObjectStore(SCHEDULE_ACTIVITY_SLOT_STORE_NAME, { keyPath: 'id', autoIncrement: true });
            scheduleActivitySlotStore.createIndex(SCHEDULE_ACTIVITY_SLOT_STORE_DATE_INDEX, 'date', {unique: false});
            scheduleActivitySlotStore.createIndex(SCHEDULE_ACTIVITY_SLOT_STORE_SYNC_STATUS_INDEX, 'syncStatus', {unique: false});
            let lessonPlanStore = db.createObjectStore(LESSON_PLAN_STORE_NAME, { keyPath: 'id', autoIncrement: true });
            lessonPlanStore.createIndex(LESSON_PLAN_STORE_BATCHID_INDEX, 'batches', {unique: false, multiEntry: true});
            lessonPlanStore.createIndex(LESSON_PLAN_STORE_TOPICID_INDEX, 'topics', {unique: false, multiEntry: true});
            let lessonPlanStepStatusStore = db.createObjectStore(LESSON_PLAN_STEP_STATUS_STORE_NAME, { keyPath: 'id', autoIncrement: true });
            lessonPlanStepStatusStore.createIndex(LESSON_PLAN_STEP_STATUS_LESSONPLANID_INDEX, 'lessonPlanId', {unique: false});
            lessonPlanStepStatusStore.createIndex(LESSON_PLAN_STEP_STATUS_SYNC_STATUS_INDEX, 'syncStatus', {unique: false});
                        
          },
        }
      );
    }
    
  async getAll(storeName: string){
      const thisInstance = this;
    if(!thisInstance.iteachDB){
      await this.connect();
    }
    return new Promise<any[]>(function (resolve, reject) {
      console.log(thisInstance.iteachDB, 'here');
      resolve(thisInstance.iteachDB.getAll(storeName))
        reject("Error while getting batches from dbservice")
  });
  }

  save(storeName: string, item: any): Promise<any> {
    const thisInstance = this;
    return new Promise<any>(function (resolve,reject){
      resolve(thisInstance.iteachDB?.put(storeName, item))
      reject("Error while saving data to dbservice")
    });
  }

  update(storeName: string, item: any): Promise<any> {
    const thisInstance = this;
    return new Promise<any>(function(resolve,reject){
      resolve(thisInstance.iteachDB?.put(storeName, item))
      reject("error while updating in dbservice")
    });  //put is used to update
  }

  saveAll(storeName: string, items: any): any {
    // put multiple records in Store
    const thisInstance = this;
    return new Promise((resolve, reject) => {
      console.log(thisInstance.iteachDB)
      let tx = thisInstance.iteachDB.transaction(storeName, 'readwrite');
      let store = tx.objectStore(storeName);
      items.forEach(function(item){
          store.put(item).then(
            () => {
              console.log('Added');
            },
            error => {
                console.log('DBError:'+ error);
            }
        );
        
      });
      tx.onabort = function() {
        // Otherwise the transaction will automatically abort due the failed request.
        console.log('Transaction Abort:'+tx. error);
        reject(0);
        
      };
      tx.oncomplete  = function() {
        console.log('Transaction Success:'+tx. error);
        resolve(1);
      };
    });
  }

  getByIndex = async(storeName: string, index: string, key: any): Promise<any>=> {
    //return from(this.iteachDB.getFromIndex(storeName, 'student_batchId_unique', key));
    //console.log(this.iteachDB.getAllFromIndex(storeName, 'student_batchId_unique', 3));
    await this.connect();
    console.log(this.iteachDB)
    return this.iteachDB.getAllFromIndex(storeName, index, key);
  }

  /**
   * Clear all records from a store (for cache invalidation)
   */
  async clearStore(storeName: string): Promise<void> {
    await this.connect();
    const tx = this.iteachDB.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    await store.clear();
    await tx.done;
    console.log(`Cleared store: ${storeName}`);
  }

}
